import type {
  CreateChannelModelRequest,
  CreateChannelModelResponse,
  DeleteChannelModelResponse,
  ListChannelModelsResponse,
  UpdateChannelModelRequest,
  UpdateChannelModelResponse,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

export function listChannelModels(
  params: { channel_id?: string; model?: string; vendor?: string },
  fetchImpl: typeof fetch = fetch,
): Promise<ListChannelModelsResponse> {
  const qs = new URLSearchParams();
  if (params.channel_id) qs.set('channel_id', params.channel_id);
  if (params.model) qs.set('model', params.model);
  if (params.vendor) qs.set('vendor', params.vendor);
  const query = qs.toString().length > 0 ? `?${qs.toString()}` : '';
  return opsApiRequest<ListChannelModelsResponse>(`/v1/ops/channel-models${query}`, { method: 'GET' }, fetchImpl);
}

export function createChannelModel(
  body: CreateChannelModelRequest,
  fetchImpl: typeof fetch = fetch,
): Promise<CreateChannelModelResponse> {
  return opsApiRequest<CreateChannelModelResponse>('/v1/ops/channel-models', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body,
  }, fetchImpl);
}

/** Epic #898 P6 (#910): per-SKU pricing PATCH (multiplier / upstream cost). */
export function updateChannelModel(
  skuId: string,
  body: UpdateChannelModelRequest,
  fetchImpl: typeof fetch = fetch,
): Promise<UpdateChannelModelResponse> {
  return opsApiRequest<UpdateChannelModelResponse>(
    `/v1/ops/channel-models/${encodeURIComponent(skuId)}`,
    {
      method: 'PATCH',
      headers: { 'content-type': 'application/json' },
      body,
    },
    fetchImpl,
  );
}

export function deleteChannelModel(
  channelId: string,
  model: string,
  fetchImpl: typeof fetch = fetch,
): Promise<DeleteChannelModelResponse> {
  return opsApiRequest<DeleteChannelModelResponse>(
    `/v1/ops/channel-models/${channelId}/${model}`,
    { method: 'DELETE' },
    fetchImpl,
  );
}
